import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import CreateButton from '../buttons/CreateButton';
import HolidaysCreateTab from './HolidaysCreateTab';
import { holidayPropertiesType } from '../../types';

CreateHolidaysRow.propTypes = {
    holidayProps: holidayPropertiesType.isRequired,
};

function CreateHolidaysRow(props) {
    const {
        holidayProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-holidays-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('holidays.create-holidays')}</CreateButton>
            {isCreateVisible && (
                <HolidaysCreateTab
                    hideHandler={() => setCreateVisible(false)}
                    holidayProps={holidayProps}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.HOLIDAY_EDIT])(CreateHolidaysRow);
